export const paymentDetails = (state) => state.paymentDetails;
export const paymentOption = (state) => state.paymentOption;
export const buyer = (state) => state.buyer;
export const interests = (state) => state.interests;
export const finalDetails = (state) => state.finalDetails;
export const pixDetails = (state) => state.pixDetails;
export const partialPayment = (state) => state.partialPayment;
export const canPurchase = (state) => state.canPurchase;
export const erroMessageCard = (state) => state.erroMessageCard;
export const countries = (state) => state.countries;
export const showSecurityCheck = (state) => state.showSecurityCheck;
export const paymentOptionsDetails = (state) => state.paymentOptionsDetails;
export const secure3dsOpen = (state) => state.secure3dsOpen;
